import React, { useState, useEffect, useMemo } from 'react'
import { Dropdown } from 'antd'
import { RetweetOutlined } from '@ant-design/icons'
import { languageList, langCache } from '@/YXUIKit/im-kit-ui/src/utils'
import commonApi from '@/api/commonApi'
import {
  useTranslation,
  useStateContext
} from '../../../common'


export interface ChatHeaderProps {
  avatar: React.ReactNode
  title: string
  subTitle?: string
  prefix?: string
  myUser?: any,
  receiverUser?: any
}


const ChatHeader: React.FC<ChatHeaderProps> = ({
  avatar,
  title,
  subTitle = '',
  prefix = 'chat',
  myUser = {},
  receiverUser = {}
}) => {
  const _prefix = `${prefix}-header`
  const { t } = useTranslation()
  const { store, nim, localOptions, locale, ppyStore } = useStateContext()
  const { pstore, setPstore } = ppyStore
  const { langMsg, langConfig } = pstore

  const [langList, setLangList] = useState<any>([])

  useEffect(()=>{
    let arr: any = []
    languageList.forEach((item: any)=>{
      item.label = t(item.key)
      arr.push(item)
    })
    setLangList(arr)
  }, [])

  const updateMenu = (item: any, index: number) => {
    let tempLangConfig = JSON.parse(JSON.stringify(langConfig))
    const receiverId = receiverUser.accountId
    if(!tempLangConfig[receiverId]){
      tempLangConfig[receiverId] = ['', '']
    }
    tempLangConfig[receiverId][index] = item.key
    if(tempLangConfig[receiverId][0] && tempLangConfig[receiverId][1] && (tempLangConfig[receiverId][0] !== tempLangConfig[receiverId][1])){
      getMsg(receiverId, tempLangConfig[receiverId])
    }
    setPstore({value: tempLangConfig, type: 'langConfig'})
    window.localStorage.setItem('langConfig', JSON.stringify(tempLangConfig))
  }
  const getMsg = (receiverId: string, activeLang: any) => {
    const conversationId = nim.V2NIMConversationIdUtil.p2pConversationId(receiverId)
    const msgs = store.msgStore.getMsg(conversationId)
    if (msgs.length !== 0) {
      let tempLangMsg = JSON.parse(JSON.stringify(langCache.msg))

      let langFrom: any = {}
      let langTo: any = {}

      const fromLang = activeLang[0]
      const toLang = activeLang[1]
      const tran = 'loading...'
      
      if(!tempLangMsg[receiverId]){
        tempLangMsg[receiverId] = {}
      }
      if(!tempLangMsg[receiverId][fromLang+toLang]){
        tempLangMsg[receiverId][fromLang+toLang] = {}
      }
      msgs.forEach((msg, index) => {
        if(msgs.length - index < 100){
          if(msg.isSelf){
            if(tempLangMsg[receiverId][fromLang+toLang][msg.messageClientId] === undefined){
              tempLangMsg[receiverId][fromLang+toLang][msg.messageClientId] = tran 
              langTo[msg.messageClientId] = msg.text
            }
          }else {
            if(tempLangMsg[receiverId][fromLang+toLang][msg.messageClientId] === undefined){
              tempLangMsg[receiverId][fromLang+toLang][msg.messageClientId] = tran
              langFrom[msg.messageClientId] = msg.text
            }
          }
        }
      })
      setPstore({value: tempLangMsg, type: 'langMsg'})
      langCache.msg = tempLangMsg
      if(JSON.stringify(langFrom) !== '{}' || JSON.stringify(langTo) !== '{}'){
        if(tran){
          if(JSON.stringify(langFrom) !== '{}'){
            translate(langFrom, fromLang, toLang, receiverId, fromLang+toLang)
          }
          if(JSON.stringify(langTo) !== '{}'){
            translate(langTo, toLang, fromLang, receiverId, fromLang+toLang)
          }
        }
      }
    }
  }
  const translate = (languageData: any, from: any, to: any, activeId: any, langKey: string) => {
    let param = {
      text: '',
      from,
      to
    }
    let arr = Object.keys(languageData).map((key)=>{
        return languageData[key]
    })
    param.text = arr.join('\n')
    commonApi.translate(param).then((result: any)=>{
      let tempLanguage = JSON.parse(JSON.stringify(langCache.msg))
      if(result.code === 1 && result.data && result.data.trans_result){
        Object.keys(languageData).forEach((key)=>{
          const text = languageData[key]
          languageData[key] = ''
          if(text){
            result.data.trans_result.forEach((item: any)=>{
              if(text.trim() === item.src){
                languageData[key] = item.dst
              }
            })
          }
        })
      }else {
        Object.keys(languageData).forEach((key: any)=>{
          languageData[key] = undefined
        })
      }
      tempLanguage[activeId][langKey] = Object.assign(tempLanguage[activeId][langKey], languageData)

      langCache.msg = tempLanguage
      setPstore({value: tempLanguage, type: 'langMsg'})
    })
  }
  const langFrom = useMemo(() => {
    let arr = ['', '']
    if(langConfig[receiverUser.accountId]){
      languageList.forEach((item: any)=>{
        if(langConfig[receiverUser.accountId][0] === item.key){
          arr[0] = t(item.key)
        }
        if(langConfig[receiverUser.accountId][1] === item.key){
          arr[1] = t(item.key)
        }
      })
    }
    return arr
  }, [langConfig, receiverUser.accountId])
  return (
    <div className={`${_prefix}-wrap`}>
      <div className={`${_prefix}-wrap-l`}>
        <div className={`${_prefix}-avatar`}>{avatar}</div>
        <div className={`${_prefix}-title`}>{title}</div>
        {subTitle ? (
          <div className={`${_prefix}-sub-title`}>{subTitle}</div>
        ) : null}
      </div>
      <div className={`${_prefix}-wrap-r`}>
        <Dropdown menu={{ items: langList, onClick: (item)=>updateMenu(item, 0) }}>
          <p style={{cursor: 'default'}}>
            {
              langFrom[0] || '请选择'
            }
          </p>
        </Dropdown>
        <RetweetOutlined style={{margin: '0 4px', color: '#ccc'}} />
        <Dropdown menu={{ items: langList, onClick: (item)=>updateMenu(item, 1) }}>
          <p style={{cursor: 'default'}}>
            {
              langFrom[1] || '请选择'
            }
          </p>
        </Dropdown>
      </div>
    </div>
  )
}

export default ChatHeader
